import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

export const $isCloning = atomFamily((documentId: string) => atom(false));
